import { render, staticRenderFns } from "./ReviewAndConfirm.vue?vue&type=template&id=0caf5bd0&scoped=true&"
import script from "./ReviewAndConfirm.vue?vue&type=script&lang=js&"
export * from "./ReviewAndConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf5bd0",
  null
  
)

export default component.exports